export function getScssRootProperty({ rootName }) {
  const getCurrentSizeFactor = getComputedStyle(
    document.documentElement
  ).getPropertyValue(rootName);
  return getCurrentSizeFactor;
}
export function setScssRootProperty({ rootName, value }) {
  document.documentElement.style.setProperty(rootName, value);
}
